import * as React from "react";
import { connect } from "react-redux";

import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";
import * as questionIds from "@teamprevent/common/healthSurveillance/questions/questionIds";
import { HealthSurveillanceSectionProps } from "@teamprevent/common/healthSurveillance/models";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";

const sectionId = "ConfidentialityAndDataProtection";

// eslint-disable-next-line max-len
const ConfidentialityAndDataProtectionSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            id={sectionId}
            title="Confidentiality and Data Protection"
        >
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.PrivacyStatementConfirmation)}
                value="Confirmed"
                mandatory
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.TeamPreventProcessPersonalInfoConfirmation)}
                value="Confirmed"
                mandatory
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.InformationHeldSecurelyConfirmation)}
                value="Confirmed"
                mandatory
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FitnessToWorkProvidedToEmployerConfirmation)}
                value="Confirmed"
                mandatory
                hideDivider
            />
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const ConfidentialityAndDataProtectionSection = connect(makeMapStateToQuestionnaireSectionProps(sectionId), mapDispatchToQuestionnaireSectionProps)(ConfidentialityAndDataProtectionSectionUnconnected);
